export default __webpack_public_path__ + "static/media/main-logo.85a6fb7a.png";